import { render } from "./TransactionItem.vue?vue&type=template&id=33a1bcdc&scoped=true&ts=true"
import script from "./TransactionItem.vue?vue&type=script&lang=ts"
export * from "./TransactionItem.vue?vue&type=script&lang=ts"

import "./TransactionItem.vue?vue&type=style&index=0&id=33a1bcdc&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33a1bcdc"]])

export default __exports__